<script>
import { mapGetters } from 'vuex';
import CampaignFilterItem from './CampaignFilterItem.vue';
import CampaignFilterModal from './CampaignFilterModal.vue';

export default {
  components: {
    CampaignFilterItem,
    CampaignFilterModal,
  },
  data() {
    return {
      sortFilter: 'scheduled_at_desc',
      open: false,
      showActionsDropdown: false,
      searchQuery: '',

      showCampaignFilterModal: false,
      filtersBeingEdited: {},
    };
  },
  computed: {
    filtersList() {
      return [
        {
          id: 'status_filter',
          label: this.$t('CAMPAIGN.FILTER.STATUS_TOOLTIP'),
          toogleFilter: this.toggleStatusFilter,
        },
        {
          id: 'origin_filter',
          label: this.$t('CAMPAIGN.FILTER.ORIGIN_TOOLTIP'),
          toogleFilter: this.toogleOrganicOrRecurringFilter,
        },
        {
          id: 'date_range_filter',
          label: this.$t('CAMPAIGN.FILTER.DATE_RANGE_FILTER'),
          toogleFilter: this.toggleDateFilter,
        },
      ];
    },

    orderingList() {
      return {
        created_at_asc: this.$t('CAMPAIGN.FILTER.ORDER_BY.CREATED_AT_ASC'),
        created_at_desc: this.$t('CAMPAIGN.FILTER.ORDER_BY.CREATED_AT_DESC'),
        scheduled_at_asc: this.$t('CAMPAIGN.FILTER.ORDER_BY.SCHEDULED_AT_ASC'),
        scheduled_at_desc: this.$t(
          'CAMPAIGN.FILTER.ORDER_BY.SCHEDULED_AT_DESC'
        ),
      };
    },
    localSearchQuery: {
      get() {
        return this.searchQuery;
      },
      set(newValue) {
        this.$emit('update:searchQuery', newValue);
      },
    },
    searchButtonClass() {
      return this.searchQuery !== '' ? 'show' : '';
    },
    ...mapGetters({
      getAppliedContactFilters: 'contacts/getAppliedContactFilters',
    }),
    hasAppliedFilters() {
      return this.getAppliedContactFilters.length;
    },
  },
  methods: {
    toggle() {
      this.open = !this.open;
    },
    toggleDateFilter() {
      this.showDateFilter = !this.showDateFilter;
      this.showFiltersOptions = false;
    },
    handleCalendarClick(event) {
      event.stopPropagation();
    },
    handleClickOutside(event) {
      const dateFilterContainer = this.$refs.dateFilterContainer;
      if (!dateFilterContainer.contains(event.target)) {
        this.isCalendarVisible = false;
      }
    },
    // closeDateFilter() {
    //   this.showDateFilter = false;
    // },
    applyDateFilter(dateRange) {
      const [start_at, end_at] = dateRange.map(date =>
        date ? new Date(date).toISOString().split('T')[0] : ''
      );
      this.$emit('dateFilterChange', { start_at, end_at });
      this.showDateFilter = false;
    },
    resetDateFilter() {
      this.dateRange = [];
      this.$emit('dateFilterChange', { start_at: '', end_at: '' });
    },
    toggleDropdown() {
      this.showActionsDropdown = !this.showActionsDropdown;
    },
    closeDropdown() {
      this.showActionsDropdown = false;
    },
    emitSearch() {
      this.$emit('search', this.searchQuery);
    },
    onChangeFilter(value, type) {
      if (type === 'sort') {
        this.sortFilter = value;
        this.$emit('changeSort', value);
        this.closeDropdown(); // Fechar a janela de seleção
      }
    },
    applyStatusFilter(filterStatusList) {
      const selectedStatuses = filterStatusList
        .filter(status => status.selected)
        .map(status => status.id);

      this.$emit('statusChange', selectedStatuses);
      this.showStatusFilter = false;
    },
    applyOrganicOrRecurringFilter(f) {
      this.$emit('organicOrRecurringFilterChange', f);
    },

    toogleCampaignFilterModal() {
      this.showCampaignFilterModal = !this.showCampaignFilterModal;
    },
    closeCampaignFilterModal() {
      this.showCampaignFilterModal = false;
    },
    editCurrentFilter(filterSettings) {
      const {
        selectedStatusFilter,
        selectedOrganicOrRecurringFilter,
        dateRange,
      } = filterSettings;

      if (selectedStatusFilter) this.applyStatusFilter(selectedStatusFilter);
      if (selectedOrganicOrRecurringFilter)
        this.applyOrganicOrRecurringFilter(selectedOrganicOrRecurringFilter);
      if (dateRange) this.applyDateFilter(dateRange);

      this.filtersBeingEdited = {
        selectedStatusFilter,
        selectedOrganicOrRecurringFilter: selectedOrganicOrRecurringFilter,
        dateRange,
      };

      this.$emit('editFilters');
      this.closeCampaignFilterModal();
    },
  },
};
</script>

<template>
  <header class="border-b border-slate-50 dark:border-slate-800 py-2">
    <div class="flex w-full justify-between">
      <div class="flex items-center max-w-full -translate-y-2">
        <h1
          class="text-lg text-slate-900 dark:text-slate-100 overflow-hidden whitespace-nowrap text-ellipsis"
        >
          {{ $t('CAMPAIGN.FILTER.TITLE') }}
        </h1>
      </div>

      <div class="flex gap-x-2">
        <!-- Pesquisa por nome da campanha -->
        <div class="w-[320px] flex items-center relative search-wrap">
          <input
            v-model="searchQuery"
            type="text"
            :placeholder="$t('CAMPAIGN.FILTER.INPUT_SEARCH')"
            class="contact-search text-base text-slate-900 dark:text-slate-100 pl-5 text-base"
            style="padding-left: 35px"
            :style="{ 'padding-right': searchQuery ? '96px' : '0px' }"
            @keyup.enter="emitSearch"
          />
          <fluent-icon
            icon="search"
            class="absolute left-2.5 top-1/2 pt-1 transform -translate-y-5 h-5 leading-9 text-sm text-slate-900 dark:text-slate-100"
          />
          <woot-button
            v-if="searchQuery"
            :is-loading="false"
            class="clear mt-1 py-1"
            :class-names="searchButtonClass"
            @click="emitSearch"
          >
            {{ $t('CAMPAIGN.FILTER.SEARCH_BUTTON') }}
          </woot-button>
        </div>

        <!-- Filtros -->
        <div class="flex relative">
          <div
            v-if="hasAppliedFilters"
            class="absolute h-2 w-2 top-1 right-3 bg-slate-500 dark:bg-slate-500 rounded-full"
          />
          <woot-button
            v-tooltip.right="$t('CAMPAIGN.FILTER.STATUS_TOOLTIP')"
            variant="smooth"
            color-scheme="secondary"
            class="selector-button"
            icon="filter"
            @click="toogleCampaignFilterModal"
          />
        </div>

        <!-- Ordenação -->
        <div class="relative flex">
          <woot-button
            v-tooltip.right="$t('CAMPAIGN.FILTER.ORDERING_TOOLTIP')"
            variant="smooth"
            size="big"
            color-scheme="secondary"
            class="selector-button"
            icon="sort-icon"
            @click="toggleDropdown"
          />
          <div
            v-if="showActionsDropdown"
            v-on-clickaway="closeDropdown"
            class="absolute top-10 right-0 text-slate-700 dark:text-slate-100 bg-white dark:bg-slate-800 border-slate-75 dark:border-slate-400 shadow-md p-4 rounded-md z-10"
          >
            <div class="items-center flex justify-between">
              <span
                class="text-slate-800 dark:text-slate-100 text-xs font-medium"
              >
                {{ $t('CAMPAIGN.FILTER.ORDER_BY_LABEL') }}
              </span>

              <CampaignFilterItem
                type="sort"
                :selected-value="sortFilter"
                :items="orderingList"
                @on-change-filter="onChangeFilter"
              />
            </div>
          </div>
        </div>
      </div>

      <woot-modal
        v-if="showCampaignFilterModal"
        v-model:show="showCampaignFilterModal"
        :on-close="() => (showCampaignFilterModal = false)"
      >
        <CampaignFilterModal
          :filters-being-edited="filtersBeingEdited"
          @close-filter-modal="() => (showCampaignFilterModal = false)"
          @edit-current-filter="editCurrentFilter"
        />
      </woot-modal>
    </div>
  </header>
</template>

<style scoped lang="scss">
.hidden-input {
  display: none;
}
.search-wrap {
  .contact-search {
    @apply pl-10 text-sm w-full h-[2.5rem] m-0;
  }

  .button {
    transition:
      opacity 100ms linear,
      transform 100ms linear;
    @apply right-1 absolute top-1/2 transform -translate-y-5 h-5 leading-9 text-sm text-slate-900 dark:text-slate-100;
  }
  .button.show {
    @apply opacity-100 visible;
  }
}
</style>
